import constants from '../constants'

const initialState = {
  resStatus: false,
  resMessage: false,
  pageNumber: 0,
  excelExportData: [],
  userContestList: [],
  userContestDetails: {},
  joinedUsersList: { results: [], totalWinArray: [] },
  joinedUserDetails: {},
  joinedUserAnswers: {},
  joinedUserTickets: {},
  isPrizeDistributionSuccess: false,
  isProcessRefundSuccess: false,
  winnersList: [],
  c: 0,
  hadSearchTerm: false,
  totalWinArray: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case constants.ADD_USER_CONTEST:
      return {
        ...state,
        resStatus: action.payload.resStatus,
        resMessage: action.payload.resMessage
      }

    case constants.EXPORT_USER_CONTEST_DATA:
      return {
        ...state,
        excelExportData: action.payload.data,
        resStatus: action.payload.resStatus
      }

    case constants.USER_CONTEST_LIST:
      return {
        ...state,
        userContestList: action.payload.data,
        resStatus: action.payload.resStatus
      }
    case constants.USER_CONTEST_DETAILS:
      return {
        ...state,
        userContestDetails: action.payload.data,
        resStatus: action.payload.resStatus
      }
      // case constants.EDIT_USER_CONTEST:
      //   return {
      //     ...state,
      //     resStatus: action.payload.resStatus,
      //     resMessage: action.payload.resMessage
      //   }
      // case constants.CLEAR_USER_CONTEST_MESSAGE:
      //   return {
      //     ...state,
      //     resMessage: ''
      //   }
      // case constants.CLEAR_USER_CONTEST_PROPS:
      //   return {
      //     userContestList: {},
      //     userContestDetails: {},
      //     resStatus: false,
      //     resMessage: ''
      //   }

      // case constants.GET_JOINED_USERS_LIST: {
      //   const payloadData = action?.payload?.data || {}
      //   const totalWinArray = action?.payload?.totalWinArray || []
      //   let pageNumber = 20
      //   if (!totalWinArray?.length) {
      //     pageNumber = action.payload.start + payloadData?.results?.length
      //   }

      //   const joinedUsersList = Object.values(payloadData).length
      //     ? {
      //         ...payloadData, results: action.payload.searchTerm ? payloadData.results : state.hadSearchTerm ? payloadData.results : [...state.joinedUsersList.results, ...payloadData.results]
      //       }
      //     : payloadData
      //   if (totalWinArray?.length || pageNumber > 0) {
      //     joinedUsersList.results = joinedUsersList.results.map((ls) => {
      //       const winner = totalWinArray?.length ? totalWinArray.find(rs => rs.userId === ls._id) : state.totalWinArray.find(rs => rs.userId === ls._id)
      //       return (winner?.nAmount) ? { ...ls, nWinningAmount: Number(winner.nAmount?.toFixed(2)) } : ls
      //     })
      //   }
      //   return {
      //     ...state,
      //     pageNumber,
      //     hadSearchTerm: !!action.payload.searchTerm,
      //     joinedUsersList,
      //     totalWinArray,
      //     resStatus: action.payload.resStatus
      //   }
      // }

      // case constants.GET_JOINED_USER_DETAILS: {
      //   return {
      //     ...state,
      //     joinedUserDetails: action.payload.data,
      //     resStatus: action.payload.resStatus
      //   }
      // }

      // case constants.GET_JOINED_USER_TICKETS: {
      //   return {
      //     ...state,
      //     joinedUserTickets: action.payload.data,
      //     resStatus: action.payload.resStatus
      //   }
      // }

      // case constants.GET_JOINED_USER_ANSWERS: {
      //   return {
      //     ...state,
      //     resStatus: action.payload.resStatus,
      //     joinedUserAnswers: action.payload.data
      //   }
      // }

      // case constants.CALCULATE_PRIZE_DISTRIBUTION: {
      //   return {
      //     ...state,
      //     resStatus: action.payload.resStatus,
      //     resMessage: action.payload.resMessage,
      //     aWinners: action.payload.data
      //   }
      // }

      // case constants.CONFIRM_PRIZE_DISTRIBUTION: {
      //   return {
      //     ...state,
      //     isPrizeDistributionSuccess: action.payload.resStatus,
      //     resStatus: action.payload.resStatus,
      //     resMessage: action.payload.resMessage
      //   }
      // }

      // case constants.PROCESS_REFUND: {
      //   return {
      //     ...state,
      //     isProcessRefundSuccess: action.payload.resStatus,
      //     resStatus: action.payload.resStatus,
      //     resMessage: action.payload.resMessage
      //   }
      // }

      // case constants.CLEAR_USER_CONTEST_EXPORT_DATA: {
      //   return {
      //     ...state,
      //     excelExportData: []
      //   }
      // }

      // case constants.GET_WINNERS_LIST:
      //   return {
      //     ...state,
      //     winnersList: action.payload.data,
      //     resStatus: action.payload.resStatus
      //   }

    default:
      return state
  }
}
